import { ElementModel, EpisodeModel } from "@api/models";
import Image from "next/image";
import Link from "next/link";
import { ComiciViewer } from "./ComiciViewer";
import { ElementAlignEnum } from "@api/models/Element";
import { logError } from "@lib/logger";
import { ContentElementEmbedLink } from "./ContentElementEmbedLink";

export type ElementProps = {
  element: ElementModel & {
    //seriesId: string;
    //episodeId: string;
    strike?: boolean;
    italic?: boolean;
    underlined?: boolean;
    episode?: EpisodeModel;
  };
};

const alignStyle = (align: ElementAlignEnum | undefined) => {
  if (!align) return "";
  switch (align) {
    case "center":
      return "mode-center";
    case "left":
      return "mode-left";
    case "right":
      return "mode-right";
  }
};

const RenderChildren = (children: ElementModel[] | undefined, episode?: EpisodeModel) => {
  if (!children) return <></>;
  return (
    <>
      {children.map((child, index) => (
        <ContentElement element={{ episode, ...child }} key={index} />
      ))}
    </>
  );
};

export default function ContentElement({ element }: ElementProps) {
  const hasSize = typeof element.width === "number" && typeof element.width === "number";
  if (!element.children && element.text && element.type !== "viewer") {
    const splitted = element.text.split("\n");
    const breaked = splitted.map((item, index) => {
      if (splitted.length === index + 1) return <span key={index}>{item}</span>;
      return (
        <span key={index}>
          {item}
          <br />
        </span>
      );
    });
    if (element.bold) return <b>{breaked}</b>;
    if (element.strike) return <span className="line-through">{breaked}</span>;
    if (element.italic) return <em>{breaked}</em>;
    if (element.underlined) return <u>{breaked}</u>;
    return <span>{breaked}</span>;
  }
  switch (element.type) {
    case "image":
      return (
        <div
          className={
            "g-desc-img-wrap " +
            (hasSize ? "mode-sized " : "mode-fill ") +
            alignStyle(element.align)
          }
        >
          <Image
            src={element.url || ""}
            fill={!hasSize}
            width={hasSize ? element.width : undefined}
            height={hasSize ? element.height : undefined}
            alt=""
            className="g-desc-img"
          />
        </div>
      );
    case "viewer":
      return element.viewerId && element.episode ? (
        <ComiciViewer viewerId={element.viewerId} episode={element.episode} />
      ) : (
        <div className="ep-main-viewer mode-error">
          <div id="comici-viewer">
            <span className="ep-main-viewer-error-message">ビューワーのロードに失敗しました</span>
          </div>
        </div>
      );
    case "paragraph":
      return (
        <div className={"g-desc-p " + alignStyle(element.align)}>
          {RenderChildren(element.children, element.episode)}
        </div>
      );
    case "header":
      return (
        <h2 className={"g-desc-h " + alignStyle(element.align)}>
          {RenderChildren(element.children, element.episode)}
        </h2>
      );
    case "link":
      return (
        <Link href={element.url || ""} className={"g-desc-link " + alignStyle(element.align)}>
          {RenderChildren(element.children, element.episode)}
        </Link>
      );
    case "quote":
      return (
        <blockquote className={"g-desc-q " + alignStyle(element.align)}>
          {RenderChildren(element.children, element.episode)}
        </blockquote>
      );
    case "embed":
      // TODO:埋め込み変換
      return <ContentElementEmbedLink element={element} />;
    case "html":
      if (element.html) {
        return <div dangerouslySetInnerHTML={{ __html: element.html }}></div>;
      } else {
        return <></>;
      }
    default:
      logError("Unknown content element type: " + element.type);
      return <></>;
  }
}
